import { render, staticRenderFns } from "./SwitchOther.vue?vue&type=template&id=6bb701a7&scoped=true"
import script from "./SwitchOther.vue?vue&type=script&lang=js"
export * from "./SwitchOther.vue?vue&type=script&lang=js"
import style0 from "./SwitchOther.vue?vue&type=style&index=0&id=6bb701a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb701a7",
  null
  
)

export default component.exports